import { configureStore } from '@reduxjs/toolkit';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import chatBotEventsSliceRecucer from './chatBotEventsSlice';
import homeVisibilityReducer from './homeVisibilitySlice';
import toggleSideNavReducer from './toggleSideNav';
import userSendPromptReducer from './userSendPromptSlicer';

// import guidePromptsReducer from './components/Prompts/Guide/GuidePromptsSearcher/guidePromptsSlice';
import cardTextSliceReducer from './cardTextSlice';
import modalActionsReducer from './modalActionsSlice';


const store = configureStore({
  reducer: {
    homeVisibility: homeVisibilityReducer,
    cardText: cardTextSliceReducer,
    chatBotEvents: chatBotEventsSliceRecucer,
    modalActions: modalActionsReducer.modalActionsSlice,
    modalComponents: modalActionsReducer.modalComponentSlice,
    toggleSideNav: toggleSideNavReducer,
    // guidePrompsSearcher: guidePromptsReducer,
    userSendPrompt: userSendPromptReducer.userSendPromptSlice
  }
})

export default store;